<template>
  <div class="list" v-if="subcategories.length > 0">
    <div class="list-item" v-for="item in subcategories" :key="item.entity_id">

      <!-- Header -->
      <div class="list-item-line">
        <h2 class="list-item-line-title"> {{ item.name }} </h2>
        <router-link :to="categoryLink(item.category)" class="list-item-line-link no-underline"> {{ $t('View all products') }} </router-link>
      </div>
      <!---->

      <!-- Slider -->
      <products-swiper :title="item.name" :total="item.product_count" :category="item" />
      <!---->

    </div>
  </div>
</template>

<script>
import ProductsSwiper from 'theme/components/core/blocks/Shop/Product/ProductsSwiper'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'CategorySwipers',
  components: {
    ProductsSwiper
  },
  data () {
    return {
      slidersToLoad: 2,
      slidersListLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner',
      categories: 'category/getCategories',
      currentCategory: 'category/getCurrentCategory'
    }),
    currentPartnerCode () {
      return this.currentPartner.code
    },
    currentLocationCode () {
      return this.$route.params.locationCode
    },
    subcategories () {
      let parentId = this.currentCategory ? this.currentCategory.entity_id : 0
      if (!parentId && this.currentPartner) {
        parentId = this.currentPartner.root_category_id
      }

      return this.categories.filter(item => item.parent_id === parentId)
    }
  },
  methods: {
    ...mapActions({
      setSlidersAmount: 'products_categories/setCategoriesLoaded',
      cleanupSliderProducts: 'products_categories/cleanupSliderProducts'
    }),
    categoryLink (category) {
      return `/${this.currentLocationCode}/${this.currentPartnerCode}${formatCategoryLink(category)}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .list {
    width: 100%;

    display: flex;
    flex-direction: column;

    &-item {
      display: flex;
      flex-direction: column;
      position: relative;

      &-line {
        width: 100%;
        margin: 15px 0;

        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 2;

        &-title {
          margin: 0;

          color: #111;
          font-size: 18px;
          font-weight: 600;
        }

        &-link {
          color: #00d800;
          font-size: 14px;
          font-weight: 400;
          text-decoration: none;

          &:hover {
            cursor: pointer;
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>
